import { getContentHasVariants } from 'features/unifiedFlow/contentPage/helpers'
import {
  useContent,
  useSelectedElement,
} from 'features/unifiedFlow/contentPage/hooks'

import ExportMenuButton from '../../components/layout/components/ExportMenuButton'
import { VariantStatus } from '../../manage/utils/variantUtils'

type Props = {
  statusFilter: VariantStatus
  hasLoadingVariants?: boolean
  tooltipPlacement: 'top' | 'left'
}

const IconsBase = ({
  statusFilter,
  hasLoadingVariants = false,
  tooltipPlacement,
}: Props) => {
  const { content } = useContent()
  const { data: selectedElement } = useSelectedElement()
  const hasVariants = getContentHasVariants(content)

  return (
    <>
      {selectedElement && hasVariants && (
        <div className="flex items-stretch">
          <ExportMenuButton
            tooltipPlacement={tooltipPlacement}
            statusFilter={statusFilter}
            disabled={hasLoadingVariants}
          />
        </div>
      )}
    </>
  )
}

export default IconsBase
